module.exports = __webpack_public_path__ + "static/media/cl.e9b67a59.svg";